import * as React from 'react';
import CR29importExportCore from './CR29ImportExportCore';
import UserRoleEnum from '../../redux/UserSlice';




const CR29ImportExport = (props: any) => {

    return (
        <React.Fragment>
            <CR29importExportCore userRole={UserRoleEnum.EntityUser} />
        </React.Fragment>
    );
}

export default CR29ImportExport;